import { render, staticRenderFns } from "./WorkspaceGraphTablePagination.vue?vue&type=template&id=d16dd168&scoped=true"
import script from "./WorkspaceGraphTablePagination.vue?vue&type=script&lang=js"
export * from "./WorkspaceGraphTablePagination.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceGraphTablePagination.vue?vue&type=style&index=0&id=d16dd168&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d16dd168",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d16dd168')) {
      api.createRecord('d16dd168', component.options)
    } else {
      api.reload('d16dd168', component.options)
    }
    module.hot.accept("./WorkspaceGraphTablePagination.vue?vue&type=template&id=d16dd168&scoped=true", function () {
      api.rerender('d16dd168', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceGraphTablePagination.vue"
export default component.exports